<div
  class="header bg-white d-flex justify-content-between align-items-center p-px-24 border-bottom"

>
  <app-custom-breadcrumb [listUrls]="listUrls"></app-custom-breadcrumb>
</div>
@if (mission) {
  <div class="card-container p-px-24 m-px-50">
    <h1 class="fs-24 fw-7">Évaluation de la prestation</h1>
    <p class="text-secondary fs-16 fw-3 pb-px-24">
      Votre feedback est précieux pour améliorer notre processus de recrutement et
      assurer la qualité des missions.
    </p>
    <app-text-separator text="La mission"></app-text-separator>
    <p class="fs-14 fw-7 pt-px-24">{{ mission.missionTitle }}</p>
    <p class="fs-13 fw-4">
      {{mission.description}}
    </p>
    <div class="py-px-6 d-flex ">
      <div class="d-flex flex-column">
        <span class="fs-13 fw-3">Début</span>
        <span class="fs-13 fw-4">{{mission.startdate | date: 'dd-MM-yyyy'}}, {{ moment(mission.starttime, 'HH:mm:ss').format('HH:mm')}}</span>
      </div>
      <div class="d-flex flex-column" style="margin-left: 20px;">
        <span class="fs-13 fw-3">Fin</span>
        <span class="fs-13 fw-4">{{mission.enddate | date: 'dd-MM-yyyy'}}, {{ moment(mission.endtime, 'HH:mm:ss').format('HH:mm')}}</span>
      </div>
    </div>
    @if(mission.adresseDto?.name)
    {
      <p class="fs-13 fw-4">
       Site: {{mission.adresseDto?.name}}
      </p>
    }
    @if(mission.serviceAffectationsName)
    {
    <p class="fs-13 fw-4">
    Service d’affectation: {{mission.serviceAffectationsName}}
    </p>
    }
    @if(mission.typePoste)
    {
    <p class="fs-13 fw-4">
     Poste: {{mission.typePoste}}
    </p>
    }
    <app-text-separator
      innerClass="py-px-24"
      text="Candidat"
    ></app-text-separator>
    <div class="card-container p-px-16 mb-px-24">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex flex-column">
          <app-user
            [text]="candidatApplied?.candidateName??candidat?.fullname"
            [withRating]="false"
            [email]="candidat.mailadress"
            [phoneNumber]="candidat.numtel"
            [imageSrc] = "candidatApplied?.candidatePhoto"
            *ngIf="candidat"
          ></app-user>
        </div>
        <div class="d-flex align-items-center">
         <app-button text="Voir profil" (handleClick)="openDetailCandidate(candidatApplied.candidatId)" [stroked]="true"></app-button>
        </div>
      </div>
    </div>
    <app-text-separator innerClass="py-px-24" text="Satisfaction"></app-text-separator>
    <div class="card-container mb-px-24">
      <div class="text-center p-px-24">
        <p class="fs-20 fw-7">Sur une échelle de 0 à 5,
          quel est votre degé de satisfaction?</p>
        <p class="fs-13 fw-3 text-secondary">Des compétences professionnelles du (de la) candidat(e) ?</p>
        <div class="d-flex justify-content-center align-items-start">
          <p class="fs-13 fw-3 text-secondary mt-3 mx-2">Insatisfait</p>
          <app-rating  (onClick)="rating($event, 'skillsRate')" [showIndexNumber]="true" [rating]="0" [readOnly]="false" [width]="40" [height]="40"></app-rating>
          <p class="fs-13 fw-3 text-secondary mt-3 mx-2">Très satisfait</p>
        </div>
      </div>

      <div class="text-center p-px-24">
        <p class="fs-13 fw-3 text-secondary">Des relations avec les membres de votre équipe ?</p>
        <div class="d-flex justify-content-center align-items-start">
          <p class="fs-13 fw-3 text-secondary mt-3 mx-2">Insatisfait</p>
          <app-rating  (onClick)="rating($event, 'connectionMemberRate')" [showIndexNumber]="true" [rating]="0" [readOnly]="false" [width]="40" [height]="40"></app-rating>
          <p class="fs-13 fw-3 text-secondary mt-3 mx-2">Très satisfait</p>
        </div>
      </div>

      <div class="text-center p-px-24">
        <p class="fs-13 fw-3 text-secondary">Des relations avec le client ou le patient et sa famille ?</p>
        <div class="d-flex justify-content-center align-items-start">
          <p class="fs-13 fw-3 text-secondary mt-3 mx-2">Insatisfait</p>
          <app-rating  (onClick)="rating($event, 'connectionClientRate')"
                       [showIndexNumber]="true" [rating]="0" [readOnly]="false" [width]="40" [height]="40"></app-rating>
          <p class="fs-13 fw-3 text-secondary mt-3 mx-2">Très satisfait</p>
        </div>
      </div>

      <div class="text-center p-px-24">
        <p class="fs-13 fw-3 text-secondary">La ponctualité du (de la) candidat(e) ?</p>
        <div class="d-flex justify-content-center align-items-start">
          <p class="fs-13 fw-3 text-secondary mt-3 mx-2">Insatisfait</p>
          <app-rating  (onClick)="rating($event, 'punctualityRate')"
                       [showIndexNumber]="true" [rating]="0" [readOnly]="false" [width]="40" [height]="40"></app-rating>
          <p class="fs-13 fw-3 text-secondary mt-3 mx-2">Très satisfait</p>
        </div>
      </div>

    </div>

    <app-custom-input type="textarea" controlName="comment" [parentForm]="form"
                      [required]="false" label="Commentaires"
                      placeholder=" Plus de précisions sur votre feedback"></app-custom-input>
    <app-button text="Confirmer et envoyer mon évaluation" innerClass="w-100" (handleClick)="sendEvaluation()" ></app-button>
  </div>

} @else {
  <app-loader></app-loader>
}
